import { Injectable } from '@angular/core';

import { AccountRecurly } from '@shared/account/models';
import { LocationRecurly } from '@shared/restaurant/models';
import { SubscriptionTypes } from '@shared/restaurant/enums';
import { PaymentPlanCodes } from '@shared/price-plan/enums';
import { PlansAlertData } from '../models';

@Injectable({ providedIn: 'root' })
export class PlanRestrictionsAlertService {
  getAlertData(
    subscriptionType: SubscriptionTypes,
    accountRecurly: AccountRecurly,
    locationRecurly: LocationRecurly,
  ): PlansAlertData {
    if (subscriptionType === SubscriptionTypes.offline) {
      return { notAvailableForPlan: '', linkText: '', afterLinkText: '' };
    }

    const onTrial = accountRecurly.trial !== undefined && accountRecurly.trial === true;
    const isFreePlan = locationRecurly.planCode === PaymentPlanCodes.Free;
    const trialNotStarted = accountRecurly.trial === undefined;
    const pricePlan = locationRecurly.planCode;
    const onBusinessPlan = pricePlan.includes('standard') ||
      pricePlan.includes('reef') ||
      pricePlan.includes('business') ||
      pricePlan.includes('premium');

    if (trialNotStarted) {
      return {
        notAvailableForPlan: 'Free Plan',
        linkText: 'Start a Free Trial',
        afterLinkText: 'of a Business Plan to give them a try.',
      };
    }

    if (isFreePlan) {
      return {
        notAvailableForPlan: 'Free Plan',
        linkText: 'Start a Business',
        afterLinkText: 'to give them a try.',
      };
    }

    if (!onBusinessPlan) {
      return {
        notAvailableForPlan: onTrial ? 'Trial Starter' : 'Starter Plan',
        linkText: 'Start a Business',
        afterLinkText: 'to give them a try.',
      };
    }

    return { notAvailableForPlan: '', linkText: '', afterLinkText: '' };
  }
}
